// extracted by mini-css-extract-plugin
export default {"text":"zhDU6XfmbFLW6-m8BiX6gQ==","textPrimary":"_8EAnrbiYQDzU6u1LPdt8WA==","textSecondary":"yKppZb0lvw2OAueqtRkl-Q=="};